import React from "react";
import tampuuriWindowObject from "../../tampuuriWindowObject.js";
import accessibility from "../../accessibility.js";
import SelectLocation from "../Components/SelectLocation.jsx";
import Rent from "../Components/Rent.jsx";
import SurfaceArea from "../Components/SurfaceArea.jsx";
import SelectRentals from "../Components/SelectRentals.jsx";
import SelectExtras from "../Components/SelectExtras.jsx";
import SelectPriceLevels from "../Components/SelectPriceLevels.jsx";

const Header = (props) => {
  const { params, callBackUrlQuery, svgObjects } = props;
  const { translate } = tampuuriWindowObject();
  const { announceMessage, globalAccessibilitySpeakerId } = accessibility();

  const submitParams = (newParams = {}) => {
    let final = { ...params, ...newParams };
    callBackUrlQuery(final);
  };

  const removeAllParams = () => {
    let final = {
      locations: [],
      rent: "",
      rentalTypes: [],
      extraInfos: [],
      priceLevels: [],
      surfaceArea: "",
      setFirstPage: true,
      hitsPerPage: 12,
      exchangeStudents: false,
    };
    callBackUrlQuery(final);
  };
  const disabledButton =
    params.locations.length === 0 &&
    params.extraInfos.length === 0 &&
    (params.priceLevels ?? []).length === 0 &&
    params.rentalTypes.length === 0 &&
    params.rent === "" &&
    params.surfaceArea === "" &&
    params.exchangeStudents === false;

  return (
    <header>
      <div className="element-block--wider">
        <div className="heading-area">
          <h1 className="type-h2">{translate("Kohdehaku")}</h1>
        </div>

        <div className="tampuuri-properties--filters">
          <SelectLocation
            params={params}
            submitParams={submitParams}
            svgObjects={svgObjects}
            title={translate("City, area, address")}
            placeholder={translate(
              "Valitse alasvetovalikosta tai etsi hakusanalla",
            )}
          />
          <div className="rent-surface-container">
            <Rent params={params} submitParams={submitParams} />
            <SurfaceArea params={params} submitParams={submitParams} />
          </div>

          <div className="rentals-and-extras">
            <SelectRentals
              params={params}
              submitParams={submitParams}
              svgObjects={svgObjects}
              addExchange={true}
            />
            <SelectExtras
              params={params}
              submitParams={submitParams}
              svgObjects={svgObjects}
            />
            <SelectPriceLevels
              params={params}
              submitParams={submitParams}
              svgObjects={svgObjects}
            />
          </div>

          <div className="query-buttons">
            <button
              disabled={disabledButton}
              id="remove-all-params"
              onClick={() => {
                removeAllParams();

                announceMessage(
                  globalAccessibilitySpeakerId,
                  translate("Removed all filters"),
                );
              }}
              className="button button-basic"
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: svgObjects?.trash_can,
                }}
              />
              {translate("Poista kaikki valinnat")}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
